import * as Animation from 'rsuite-utils/lib/Animation';
export var dispalyName = 'Animation';
export default Animation;